import axios from 'axios';

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/esdmp`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('uemp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
